import { render, staticRenderFns } from "./ChannelPart3.vue?vue&type=template&id=0fed26aa&scoped=true&"
import script from "./ChannelPart3.vue?vue&type=script&lang=js&"
export * from "./ChannelPart3.vue?vue&type=script&lang=js&"
import style0 from "./ChannelPart3.vue?vue&type=style&index=0&id=0fed26aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fed26aa",
  null
  
)

export default component.exports